// @flow

import styled, { css } from 'styled-components';

export const Separator = styled.div`
  margin: 12px 0;
  width: 100%;
  height: 1px;

  ${props => props.line && css`
    margin: 24px 0;
    background: ${props => props.theme.colors.gray(95)};
  `}
`;
